import React from "react";
import PermitApprovers from "../PermitApprovers";
import { issuanceRenewalIdSupportingDocuments, WorkPermitApprover } from "../../../constants/common";
import RequestingDepartmentInformation from "./RequestingDepartmentInformation";
import SupportingDocuments from "../SupportingDocuments";
import Wrapper from "../Wrapper";

interface IssuanceRenewalIdPermitPDFProps {
  permitDetails: {
    s_ContractorEmployeeName: string;
    s_Nationality_En: string;
    s_NationalID: string;
    dt_NationalIDExpiryDate: any;
    dt_DateOfBirth: any;
    s_ContractorCompanyName: string;
    s_Department: string;
    s_JobPosition: string;
    dt_WorkStartDate: any;
    s_ResidentialAddress: string;
    s_ContactNumber: string;
    dt_CardValidityFrom: any;
    dt_CardValidityUntil: any;

    havePersonalPhotographFile: boolean;
    haveNationalIDCopyFile: boolean;
    haveAuthorizationLetterFile: boolean;
    
    approvers: WorkPermitApprover[];
  };
}

const IssuanceRenewalIdPermitPDF: React.FC<IssuanceRenewalIdPermitPDFProps> = ({
  permitDetails,
}) => {
  return (
    <Wrapper title='Issuance or Renewal of ID for Staff from Contracted Companies'>
      <RequestingDepartmentInformation permitDetails={permitDetails} />
      <SupportingDocuments sectionNumber={2} permitDetails={permitDetails} documents={issuanceRenewalIdSupportingDocuments} />
      <PermitApprovers sectionNumber={3} approvers={permitDetails?.approvers} />
    </Wrapper>
  );
};

export default IssuanceRenewalIdPermitPDF;
